import { render } from "./ContractServiceDeal.vue?vue&type=template&id=6f572158&scoped=true"
import script from "./ContractServiceDeal.vue?vue&type=script&lang=js"
export * from "./ContractServiceDeal.vue?vue&type=script&lang=js"

import "./ContractServiceDeal.vue?vue&type=style&index=0&id=6f572158&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f572158"]])

export default __exports__